// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Gateway = function Gateway(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M3.234 10.057h1.532v1.029a.172.172 0 00.05.121.17.17 0 00.12.05h6.128a.17.17 0 00.12-.05.172.172 0 00.05-.121V4.914a.172.172 0 00-.05-.121.17.17 0 00-.12-.05H4.936a.17.17 0 00-.12.05.172.172 0 00-.05.121v1.029H3.234V4.057a.863.863 0 01.249-.606.848.848 0 01.6-.251h7.83a.848.848 0 01.6.251.863.863 0 01.249.606v2.914h2.553l.685.686h-3.234v4.286a.863.863 0 01-.249.606.848.848 0 01-.6.251H4.085a.848.848 0 01-.6-.251.863.863 0 01-.249-.606zM1.872 9.029l-.681-.686h7.32l.68.686zM.681 7.657L0 6.971h7.319L8 7.657z"
    }))
  );
};

export default Gateway;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Gateway.js
// module id = 1014
// module chunks = 0